import React from 'react';
import { 
  FormGroup, 
  FormControlLabel, 
  Checkbox,
  TextField
} from '@mui/material';

/**
 * Component for user preferences checkboxes
 */
const UserPreferencesFields = ({ 
  optInStats, 
  setOptInStats, 
  optInVideo, 
  setOptInVideo, 
  optInSocials, 
  setOptInSocials,
  register
}) => {
  return (
    <>
      <FormGroup sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={optInStats}
              onChange={(e) => setOptInStats(e.target.checked)}
            />
          }
          label="Ik wens een rapport met mijn statistieken te ontvangen na de sessie."
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={optInVideo}
              onChange={(e) => setOptInVideo(e.target.checked)}
            />
          }
          label="Ik ga akkoord dat beeldmateriaal van mij en mijn mederenners wordt opgenomen om een overzichtsvideo van de sessie te maken."
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={optInSocials}
              onChange={(e) => setOptInSocials(e.target.checked)}
            />
          }
          label="Ik ga akkoord dat beelden waar ik in verschijn gedeeld mogen worden op sociale media (vul je Instagram naam in als je getagged wilt worden)."
        />
      </FormGroup>
      
      {/* Instagram Handle - only show when optInSocials is checked */}
      {optInSocials && (
        <TextField
          label="Instagram Handle"
          {...register('instagram_handle')}
          placeholder='Vul je Instagram handle in als je getagged wilt worden.'
          InputLabelProps={{ shrink: true }}
          sx={{ mt: 2 }}
        />
      )}
    </>
  );
};

export default UserPreferencesFields; 